import { render, staticRenderFns } from "./Title_Department.vue?vue&type=template&id=78a4c136&scoped=true&"
import script from "./Title_Department.vue?vue&type=script&lang=js&"
export * from "./Title_Department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a4c136",
  null
  
)

export default component.exports